import { IUserData } from '../features/user';

export function getUserBalance(wsBalance?: string, user?: IUserData) {
  return `${wsBalance || `${user?.balance || 0}(${user?.lockedBalance || 0})`}`;
}
